<template>
<!-- height="95px" -->
  <el-carousel
    direction="horizontal"
    indicator-position="none"
    :autoplay="false"
    arrow="never"
  >
    <el-carousel-item v-for="(item,index) in swipe_list" :key="index" >
      <img @click="url_click(item)" :src="item.content" alt />
    </el-carousel-item>
    <!-- <el-carousel-item >
      <img src="http://g.hiphotos.baidu.com/zhidao/pic/item/ac4bd11373f08202b4a9a53a4bfbfbedab641bff.jpg" alt="">
    </el-carousel-item>-->
  </el-carousel>
</template>
<script>
export default {
  props: ["swipe_list"],
  methods: {
    url_click(item) {
    //   window.location.href = item.link;
    window.open(item.link, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
.el-carousel {
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  .el-carousel__item {
    // padding: 0 50px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>